import React, {useEffect} from 'react';
import {Nav} from 'react-bootstrap';

import {
  BrowserRouter,
  Link,
  Redirect,
  Route,
  Switch,
  useLocation,
} from 'react-router-dom';

import {Home} from '#pages/home';
import {About} from '#pages/about';
import {Projects} from '#pages/projects';
import {Article} from '#pages/article';
import {NotFound} from '#pages/notFound';

import {ScrollToTop} from './ScrollToTop';

const externalRoutes = {
  github: 'https://github.com/nick-bull',
  linkedin: 'https://uk.linkedin.com/in/nick-bull-975295108',
  stackoverflow: 'https://stackoverflow.com/users/2483271/nick-bull',
  npm: 'https://npmjs.org/~nick-bull',
  cv: 'https://bull.dev/cv/20250203.pdf',
};
const externalRouteEntries = Object.entries(externalRoutes);

export const ExternalRoute = ({path, url}) => (
  <Route path={path} component={() => window.location.replace(url)} />
);
const externalRouteComponents = externalRouteEntries.map(([key, url]) => (
  <ExternalRoute path={`/${key}`} key={key} url={url} />
));

export const SiteRouter = ({}) => {
  return (
    <React.Fragment>
      <BrowserRouter>
        <ScrollToTop />

        <Nav className="navigation" defaultActiveKey="/" as="ul">
          <Nav.Item className="navigation--item" as="li">
            <Nav.Link as={Link} to="/">Home</Nav.Link>
          </Nav.Item>

          <Nav.Item className="navigation--item" as="li">
            <Nav.Link as={Link} to="/about">About</Nav.Link>
          </Nav.Item>

          <Nav.Item className="navigation--item" as="li">
            <Nav.Link as={Link} to="/projects">Projects</Nav.Link>
          </Nav.Item>
        </Nav>

        <Switch>
	  <Route path="/about" exact>
            <About />
	  </Route>

	  <Route path="/projects/:slug">
	    <Article />
	  </Route>

	  <Route path="/projects" exact>
            <Projects />
	  </Route>

          <Route path="/" exact>
            <Home />
          </Route>

	  <Route path="/404" exact>
            <NotFound />
	  </Route>

	  {externalRouteComponents}

	  <Route>
            <Redirect to="/404" />
	  </Route>
        </Switch>
      </BrowserRouter>
    </React.Fragment>
  );
};

